module.exports = __webpack_public_path__ + "img/move_to_inbox.9ea086ff.svg";